export const infoPedimentoGet = (pedimentoId) =>
    // eslint-disable-next-line implicit-arrow-linebreak
    fetchApi("api/pedimentos", {
        method: "POST",
        body: JSON.stringify({
            filtros: [
                {
                    filtro: "igual",
                    campo: "id",
                    valor: pedimentoId,
                },
            ],
        }),
        headers: {
            "Content-Type": "application/json",
        },
        default: [],
    });
